import { Injectable } from "@angular/core";
import { Building } from "@edl-development/edl-common";
import { LocalStorageKeys } from "../../model/enum/local-storage-keys.enum";
import { LocalStorageLocationKeys } from "../../model/enum/local-storage-location-keys.enum";
import { ALL_ROLES_USER_TYPE, SupervisionManagementHelpersService } from "../../services/supervision-management-helpers/supervision-management-helpers.service";
import { SessionHelpersService } from "../session-helpers-service/session-helpers.service";
import { USER_TYPES_DETAILS } from "../../supervision-management/interface/user-summary-details.interface";
import { Transition } from "@uirouter/core";

@Injectable()
export class ParamHelperService {

    constructor(
        private sessionHelpersService: SessionHelpersService,
        private supervisionManagementHelpersService: SupervisionManagementHelpersService
    ) { }

    getAllAdjustedParams = (
        transition: Transition, 
        location: LocalStorageLocationKeys, 
        filteredUserTypes: USER_TYPES_DETAILS[] = [], 
        buildings: Building[] = []
    ) => {
        const { userType, bid, searchBy, isSupervisorOnly, evaluators } = transition.params();

        const adjustedSelectFormBuildingId = this.getAdjustedBuildingId(location, buildings, bid);
        const adjustSearchBy = this.getAdjustSearchBy(location, searchBy);
        const adjustedIsSupervisorOnly = this.getAdjustedIsSupervisorOnly(location, filteredUserTypes, isSupervisorOnly);
        const adjustedUserType = this.getAdjustUserType(location, filteredUserTypes, userType, adjustedIsSupervisorOnly);
        const adjustedEvaluators = this.getAdjustEvaluators(location, evaluators);

        return {
            bid: adjustedSelectFormBuildingId,
            searchBy: adjustSearchBy,
            isSupervisorOnly: adjustedIsSupervisorOnly,
            userType: adjustedUserType,
            evaluators: adjustedEvaluators
        }
    }

    public getAdjustedBuildingId(location: LocalStorageLocationKeys, buildings: Building[] = [], bid?: number): number {
        let defaultBuildingId = this.sessionHelpersService.getFromLocalStorageLocation(LocalStorageKeys.USER_DEFAULT_BUILDING, location) as number;

        let defaultBuilding = buildings.find(b => b.buildingID == defaultBuildingId);
        if (defaultBuilding == undefined) defaultBuildingId = buildings[0].buildingID;

        return bid ?? defaultBuildingId ?? buildings[0].buildingID;
    }

    public getAdjustSearchBy(location: LocalStorageLocationKeys, searchBy?: string): string {
        const defaultSearchString = this.sessionHelpersService.getFromLocalStorageLocation(LocalStorageKeys.USER_DEFAULT_SEARCH_STRING, location) as string;

        return searchBy ?? defaultSearchString ?? "";
    }

    public getAdjustedIsSupervisorOnly(location: LocalStorageLocationKeys, filteredUserTypes: USER_TYPES_DETAILS[] = [], isSupervisorOnly?: boolean): boolean | undefined {
        const hasAllRolesFilter = filteredUserTypes.some(ut => ut.id === ALL_ROLES_USER_TYPE.id)
        const defaultIsSupervisorOnly = this.sessionHelpersService.getFromLocalStorageLocation(LocalStorageKeys.USER_DEFAULT_SUPERVISOR_ONLY, location) as boolean | undefined;
        
        return (isSupervisorOnly ?? defaultIsSupervisorOnly ?? (hasAllRolesFilter ? undefined : false));
    }

    public getAdjustUserType(location: LocalStorageLocationKeys, filteredUserTypes: USER_TYPES_DETAILS[] = [], userType?: string, isSupervisorOnly?: boolean)  {
        const defaultUserRole = this.sessionHelpersService.getFromLocalStorageLocation(LocalStorageKeys.USER_DEFAULT_ROLE_SEARCH, location) as string | undefined;

        const defaultUserType = this.supervisionManagementHelpersService.getDefaultUserType(filteredUserTypes);
        const adjustedUserType = userType ?? defaultUserRole ?? defaultUserType?.displayName;

        return filteredUserTypes.find(u => u.roleName === adjustedUserType && u.isSupervisorOnly === isSupervisorOnly && !u.disabled) ?? defaultUserType;
    }

    public getAdjustEvaluators(location: LocalStorageLocationKeys, evaluators?: string[]): string[] {
        const defaultEvaluators = this.sessionHelpersService.getFromLocalStorageLocation(LocalStorageKeys.USER_DEFAULT_PEER_EVALUATORS, location) as string[] | undefined;

        return evaluators ?? defaultEvaluators ?? [];
    }
}